<template>
  <div
    class="payment-feature-warpper position-relative section-space--pt_120 section-space--pb_120 mb-4"
    id="about"
  >
    <div class="payment-feature">
      <div class="container">
        <!-- Titulo -->
        <div
          class="
            section-title-wrapper
            text-center
            section-space--mb_60
            wow
            move-up
          "
        >
          <h2 class="section-title mb-30 font-weight-bold">
            {{ text_section.title }}
          </h2>
          <div
            class="
              elementor-element elementor-element-79f9810
              elementor-widget-divider--view-line
              elementor-widget elementor-widget-divider
            "
            data-id="79f9810"
            data-element_type="widget"
            data-widget_type="divider.default"
          >
            <div class="elementor-widget-container">
              <div class="elementor-divider">
                <span class="elementor-divider-separator"> </span>
              </div>
            </div>
          </div>

          <span class="section-text wow move-up mt-4">
            {{ text_section.text_description }}
          </span>
        </div>
        <!-- fin Titulo -->

        <div class="row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <img
              src="../../assets/img/forum/pc.png"
              alt="laptop-premium"
              class="imagen-laptop mb-4"
            />
          </div>
        </div>

        <!-- Payment Feature component -->
        <PremiumFeatures />
      </div>
    </div>
  </div>
</template>

<script>
import PremiumFeatures from "../features/premiumFeatures";

export default {
  name: "UsuariosPremium",
  components: {
    PremiumFeatures,
  },
  data() {
    return {
      text_section: {
        title: "Usuarios Premium",
        text_description:
          "Los tutores de las cuentas Premium de Progrentis EDU y ANALÍTICA tienen acceso gratuito al Campus Virtual.",
        img: "../../assets/img/forum/laptop.svg",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.imagen-laptop {
  max-width: 500px;
  width: 80%;
}
</style>